import { useParams } from 'react-router';
import { useAuthInfo } from '../_app/use-auth-info';

export const useIsMe = (username: string | undefined = undefined) => {
  const authInfo = useAuthInfo();
  const { username: usernameParam } = useParams();
  const comparedUsername = username || usernameParam;

  return authInfo.username.length > 0 && authInfo.username === comparedUsername;
};
